<template>
    <div v-if="cartTotals">
        <div class="pb-2 pt-3 d-flex justify-content-end bg-light">
            <div class="col-12 col-lg-6">
                <p class="my-0">
                    <span>Subtotal:</span> <span class="float-right"> {{ formatDollars(isPromotion ? 0 : cartTotals.subtotal) }}</span>
                </p>
                <template v-for="lineItem in lineItems">
                    <p class="my-0">
                        <span>{{ lineItem.description }}<span v-if="lineItem.qty > 1"> ({{ lineItem.qty }})</span>:</span>
                        <span class="float-right">{{ formatDollars(lineItem.total) }}</span>
                    </p>
                </template>
                <template v-if="totalsLoading">
                    <i class="fa fa-spinner fa-spin"></i>
                </template>
                <template v-else>
                    <p class="my-0" v-if="!isPromotion && cartTotals.shipping_cost > 0">
                        <span>Shipping:</span>
                        <span class="float-right">{{ formatDollars(cartTotals.shipping_cost) }}</span>
                    </p>
                    <p class="my-0" v-if="!isPromotion && cartTotals.flatShippingCost > 0">
                        <span>Flat Shipping:</span>
                        <span class="float-right">{{ formatDollars(cartTotals.flatShippingCost) }}</span>
                    </p>
                    <p class="my-0" v-if="!isPromotion && cartTotals.sales_tax > 0">
                        <span>Tax:</span>
                        <span class="float-right">{{ formatDollars(cartTotals.sales_tax) }}</span>
                    </p>
                    <p class="mb-0 d-flex justify-content-between align-items-center">
                        <span class="font-weight-bold">Total:</span>
                        <span class="font-weight-bold">{{ formatDollars(isPromotion ? 0 : cartTotals.total) }}</span>
                    </p>
                    <p class="my-0" v-if="!isPromotion && cartTotals.discount">
                        <span>Discount: </span>
                        <span class="float-right text-success">
                            -{{ formatDollars(cartTotals.discount) }}
                        </span>
                    </p>
                    <p class="my-0" v-if="!isPromotion && cartTotals.available_credit">
                        <span>Credit Applied: </span>
                        <span class="float-right text-success">
                            -{{ formatDollars(cartTotals.available_credit) }}
                        </span>
                    </p>
                    <p class="my-0" v-if="!isPromotion && cartTotals.balance != cartTotals.total">
                        <span class="font-weight-bold">Balance: </span>
                        <span class="float-right font-weight-bold">
                            {{ formatDollars(cartTotals.balance) }}
                        </span>
                    </p>

                    <p v-if="!isPromotion && getCheckoutSavings > 0" class="mt-2 mb-1 text-right text-secondary text-small">
                        You are saving <span class="text-success">{{ formatDollars(getCheckoutSavings) }}</span>
                    </p>
                </template>
            </div>
        </div>

        <div v-if="for_user" class="bg-lighter px-3 py-2 border-top">
            <p v-if="for_user.tax_exempt" class="mb-0">(user is tax exempt)</p>
            <template v-else>
                <div class="form-row col-12 col-sm-6">
                    <div class="form-check mb-3">
                        <input @change="disableTaxChanged($event)" type="checkbox" class="form-check-input"
                            id="disable_tax_check" v-model="formUpdateDisableTax.mtd_disable_tax" />
                        <label class="mb-0" for="disable_tax_check">Disable tax for this order</label>
                    </div>
                </div>
                <div class="form-row col-12 col-sm-6" v-if="!mtd_disable_tax">
                    <label for="tax_zip" class="col-6">Tax zip code</label>
                    <input type="text" class="form-control col-6" :value="sales_tax_override_zip" @change="setTaxZip" />
                </div>
            </template>
        </div>

    </div>
</template> 

<script>
import Quantity from '@/Shared/Quantity'
import ProductRow from '@/Components/Shop/ProductRow'
import AutoComplete from 'primevue/autocomplete'

import AddCustomProduct from '@/Components/Modals/AddCustomProduct'

export default {
    data() {
        return {
            formObject: this.$inertia.form({
                item_id: null,
                qty: null
            }),
            formDeleteItem: this.$inertia.form({
                item_id: null
            }),
            formUpdateDisableTax: this.$inertia.form({
                mtd_disable_tax: this.mtd_disable_tax,
                sales_tax_override_zip: this.sales_tax_override_zip
            }),
            formUpdateProduct: this.$inertia.form({
                item_id: null
            }),
            formCart: this.$inertia.form({
                qty: null,
                product_id: null
            }),
            formAddProduct: this.$inertia.form({
                sku: null,
                name: null,
                user_price: null
            }),
            quickSearchProductResults: [],
            selectedAddProduct: null
        }
    },
    components: {
        ProductRow,
        Quantity,
        AutoComplete,
        AddCustomProduct
    },
    props: {
        lineItems: Array,
        cartTotals: Array,
        isWholesale: {
            type: Boolean,
            default: false
        },
        mtd_disable_tax: {
            type: Boolean,
            default: false
        },
        sales_tax_override_zip: {
            type: Number,
            default: null
        },
        for_user: {
            type: Object,
            default: null
        },
        updateItemRoute: String,
        deleteItemRoute: String,
        toggleTaxDisabledRoute: String,
        totalsLoading: {
            type: Boolean,
            default: false
        },
        isPromotion: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        getCheckoutSavings() {
            return (this.cartTotals.fullPriceSubtotal - this.cartTotals.subtotal) +
                (this.cartTotals.discount || 0)
        },
        getUpdateItemRoute() {
            if (this.updateItemRoute) return this.updateItemRoute;
            return this.route(this.isWholesale ? 'mtd.cart.updateItem' : 'cart.updateItem')
        },
        getDeleteItemRoute() {
            if (this.deleteItemRoute) return this.deleteItemRoute;
            return this.route(this.isWholesale ? 'mtd.cart.deleteItem' : 'cart.deleteItem');
        },
        getToggleTaxDisabledRoute() {
            if (this.toggleTaxDisabledRoute) return this.toggleTaxDisabledRoute;
            return this.route('mtd.cart.settaxdisabled');
        }
    },
    methods: {
        saveItem(item) {
            this.formObject.item_id = item.id
            this.formObject.qty = item.qty

            this.formObject.post(this.getUpdateItemRoute, {
                preserveScroll: true,
                onSuccess: () => this.update()
            })
        },
        deleteItem(item) {
            if (this.formDeleteItem.processing) return;
            this.formDeleteItem.item_id = item.id
            this.formDeleteItem.post(this.getDeleteItemRoute, {
                preserveScroll: true,
                onSuccess: () => this.update()
            })
        },
        quantityChanged($event, item) {
            item.qty = $event.target.value
            this.saveItem(item)
        },
        increaseQuantity(item) {
            item.qty++
            this.saveItem(item)
        },
        decreaseQuantity(item) {
            item.qty--
            this.saveItem(item)
        },
        update() {
            this.$emit('onUpdate')
        },
        accountBalanceChanged() {
            this.$emit('balanceUpdated', this.cartTotals)
            this.update()
        },
        disableTaxChanged(e) {
            this.formUpdateDisableTax.post(this.getToggleTaxDisabledRoute, {
                preserveScroll: true,
                onSuccess: () => this.update()
            })
        },
        setTaxZip(e) {
            this.formUpdateDisableTax.sales_tax_override_zip = e.target.value;
            this.formUpdateDisableTax.post(this.route('mtd.cart.settaxpostcode'), {
                preserveScroll: true,
                onSuccess: () => this.update()
            })
        },
        changeToInventory(item) {
            if (item.from_inventory || this.formUpdateProduct.processing) return;

            this.formUpdateProduct.item_id = item.id;
            this.formUpdateProduct.post(this.route('mtd.cart.changeToInventory'), {
                preserveScroll: true,
                onSuccess: () => this.update()
            })
        },
        changeToShipping(item) {
            if (!item.from_inventory || this.formUpdateProduct.processing) return;

            this.formUpdateProduct.item_id = item.id;
            this.formUpdateProduct.post(this.route('mtd.cart.changeToShipping'), {
                preserveScroll: true,
                onSuccess: () => this.update()
            })
        },
        quickSearchProducts(event) {

            axios.post(this.route('mtd.products.search'), { query: event.query }).then((response) => {
                if (response.data.success) {
                    this.quickSearchProductResults = response.data.results;
                    if (!this.isWholesale) {
                        this.quickSearchProductResults[this.quickSearchProductResults.length] = { id: -1, sku: event.query }
                    }
                }
            });
        },
        quickAddProduct(event) {
            if (this.formCart.processing) return

            let product = event.value;

            this.selectedAddProduct = null;

            if (product.id != -1) {
                this.formCart.qty = 1,
                    this.formCart.product_id = product.id

                this.formCart.post(this.route(this.isWholesale ? 'mtd.cart.add' : 'cart.add', product.id), {
                    preserveScroll: true,
                    onSuccess: () => { }
                })
            } else {
                this.formAddProduct.sku = event.value.sku;

                $('#quickAddProductModal').modal('show')
            }
        },
    },
}
</script>

<style scoped>
.total-text {
    font-size: 1.15rem;
}
</style>